import store from "@/store/store";

const checkSisterAccess = (to, from, next) => {
  const account = store.state.account || {};
  const userAccess = account.userAccess || [];
  const hasAccess =
    userAccess.includes("pusdatin") ||
    userAccess.includes("kepegawaian") ||
    userAccess.includes("sister");

  if (hasAccess) {
    next();
  } else {
    next("/apps");
  }
};

export default [
  {
    path: "/sister/setting",
    name: "sister-setting",
    component: () => import("../../views/sister/SettingSister.vue"),
    beforeEnter: checkSisterAccess,
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Sister", url: "/submenu/sister" },
        { title: "Pengaturan Integrasi", active: true },
      ],
      pageTitle: "Pengaturan Integrasi SISTER",
    },
  },
  {
    path: "/sister/dosen",
    name: "sister-dosen",
    component: () => import("../../views/sister/DataDosenSister.vue"),
    beforeEnter: checkSisterAccess,
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Sister", url: "/submenu/sister" },
        { title: "Data Dosen", active: true },
      ],
      pageTitle: "Sinkronisasi Data Dosen SISTER",
    },
  },
  {
    path: "/sister/referensi",
    name: "sister-referensi",
    component: () => import("../../views/sister/ReferensiSister.vue"),
    beforeEnter: checkSisterAccess,
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Sister", url: "/submenu/sister" },
        { title: "Referensi SISTER", active: true },
      ],
      pageTitle: "Data Referensi SISTER DIKTI",
    },
  },
  {
    path: "/sister/jafung",
    name: "sister-jafung",
    component: () => import("../../views/sister/VerifikasiJafungSister.vue"),
    beforeEnter: checkSisterAccess,
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Sister", url: "/submenu/sister" },
        { title: "Verifikasi Jafung", active: true },
      ],
      pageTitle: "Verifikasi Jabatan Fungsional Dosen SISTER",
    },
  },
];

